// Copyright (c) 2016 Deere & Company

import SearchResults from '../state/search-results';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const filterSearchResults = (state, action) =>
    SearchResults.update(state, {
        $set: action.filteredSearchResults
    });

const actionTypes = {
    [actions.FILTER_PART_REQUESTS_SEARCH_RESULTS]: filterSearchResults
};

export default (state = getDefaultState().filteredSearchResults, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/filtered-search-results.js